import WhatsappTemplatesAPI from 'dashboard/api/pipelines/whatsappTemplates';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isSyncing: false,
  },
};

export const getters = {
  getTemplates(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  fetch: async ({ commit }, { inboxId }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await WhatsappTemplatesAPI.list(inboxId);
      commit('SET_RECORDS', response.data?.templates || []);
    } catch (e) {
      commit('SET_RECORDS', []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit, dispatch }, { inboxId, template }) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await WhatsappTemplatesAPI.create(inboxId, template);
      commit('ADD_RECORD', response.data);
      await dispatch('fetch', { inboxId });
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit, dispatch }, { inboxId, id, template }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      await WhatsappTemplatesAPI.update(inboxId, id, template);
      await dispatch('fetch', { inboxId });
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ commit, dispatch }, { inboxId, name, hsmId }) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsappTemplatesAPI.remove(inboxId, { name, hsm_id: hsmId });
      commit('REMOVE_RECORD', name);
      await dispatch('fetch', { inboxId });
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  sync: async ({ commit, dispatch }, { inboxId }) => {
    commit('SET_UI_FLAG', { isSyncing: true });
    try {
      await WhatsappTemplatesAPI.sync(inboxId);
      await dispatch('fetch', { inboxId });
    } finally {
      commit('SET_UI_FLAG', { isSyncing: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_RECORDS(_state, records) {
    _state.records = Array.isArray(records) ? records : [];
  },

  ADD_RECORD(_state, record) {
    _state.records = [..._state.records, record];
  },

  UPDATE_RECORD(_state, record) {
    const idx = _state.records.findIndex(r => r.id === record.id);
    if (idx !== -1) {
      _state.records = [
        ..._state.records.slice(0, idx),
        record,
        ..._state.records.slice(idx + 1),
      ];
    }
  },

  REMOVE_RECORD(_state, name) {
    _state.records = _state.records.filter(r => r.name !== name);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
